<template>
  <v-btn
    v-bind="$attrs"
    height="40px"
    depressed
    class="secondary"
    @click="$emit('click')"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>

<style></style>
